/**
 * Feature flag component wrapper that checks for the existence of a feature flag
 *  before deciding whether or not to render the provided components
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import React, { useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { selectors } from 'client/app/js/reducer'
import { useFeatureFlagActions } from 'client/shared/js/services/featureFlags/hooks'
import utils from '../utils'

export const FeatureFlagWrapper = ({
  userFeatureFlags,
  featureName,
  flagName,
  defaultComponent,
  children
}) => {
  const featureFlags = useSelector(selectors.selectFeatureFlags)
  const { getFeatureFlags } = useFeatureFlagActions()

  useEffect(() => {
    getFeatureFlags()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const shouldShowFeature = useMemo(() => {
    return utils.shouldShowFeature({
      featureFlags,
      userFeatureFlags,
      featureName,
      flagName
    })
  }, [featureFlags, userFeatureFlags, featureName, flagName])

  return (shouldShowFeature) ? <>{children}</> : <>{defaultComponent}</>
}

FeatureFlagWrapper.propTypes = {
  userFeatureFlags: PropTypes.object.isRequired,
  featureName: PropTypes.string.isRequired,
  flagName: PropTypes.string.isRequired,
  children: PropTypes.node,
  defaultComponent: PropTypes.node
}

FeatureFlagWrapper.defaultProps = {
  featureFlags: {},
  userFeatureFlags: {},
  defaultComponent: null
}

export default FeatureFlagWrapper
